import { graphql } from '../../gql';

export const GET_DELIVERY_PROFILE_QUERY = graphql(`
  query GetDeliveryProfileEditor($deliveryProfileId: ID!) {
    deliveryProfile(deliveryProfileId: $deliveryProfileId) {
      id
      name
      originCountryCode
      originRegionCode
      originPostalCode
      processingTime {
        min
        max
        unit
      }
      default {
        type
        rate
        additionalItemRate
      }
      otherInternational {
        type
        rate
        additionalItemRate
      }
      zones {
        id
        countries {
          code
        }
        rate {
          type
          rate
          additionalItemRate
        }
      }
    }
  }
`);

export const GET_DELIVERY_PROFILES = graphql(`
  query GetDeliveryProfilesEditor {
    deliveryProfiles {
      id
      name
      originCountryCode
      originRegionCode
      originPostalCode
      processingTime {
        min
        max
        unit
      }
      default {
        type
        rate
        additionalItemRate
      }
      zones {
        id
      }
    }
  }
`);

export const SET_DELIVERY_PROFILE_MUTATION = graphql(`
  mutation SetDeliveryProfileEditor($deliveryProfile: SetDeliveryProfileInput!) {
    setDeliveryProfile(deliveryProfile: $deliveryProfile) {
      id
      name
      originCountryCode
      originRegionCode
      originPostalCode
      processingTime {
        min
        max
        unit
      }
      default {
        type
        rate
        additionalItemRate
      }
      zones {
        id
        countries {
          code
        }
        rate {
          type
          rate
          additionalItemRate
        }
      }
      createdAt
      updatedAt
    }
  }
`);

